module.exports = __webpack_public_path__ + "static/media/b1_p9_narration_b.8d3cf74e.mp3";